/** @jsxImportSource @emotion/react */

import React from 'react'
import MuiTextField, { TextFieldProps } from '@mui/material/TextField'
import { NumericFormat } from 'react-number-format'

import { grey } from '@mui/material/colors'

type PropsType = TextFieldProps & {
	className?: string
}

/**
 * MUI TextField 의 `InputProps.inputComponent` 로 끼우는 콤마 입력.
 * 값은 콤마 없는 문자열로 올린다 — `onChange` 가 받는 `e.target.value` 는 `"1500000"`.
 * MUI v5+ 는 inputComponent 에 `ref` 를 넘기므로 forwardRef 여야 한다(아니면 콘솔 경고).
 */
export const RenderCurrencyFormatTextField = React.forwardRef<HTMLInputElement, any>(
	(props, ref) => {
		const { inputRef, onChange, ...other } = props

		return (
			<NumericFormat
				{...other}
				getInputRef={ref ?? inputRef}
				onValueChange={values => {
					onChange({
						target: {
							name: props.name,
							value: values.value,
						},
					})
				}}
				thousandSeparator
			/>
		)
	},
)
RenderCurrencyFormatTextField.displayName = 'RenderCurrencyFormatTextField'

export const TextField = (props: PropsType) => {
	const isReadOnly: boolean = props.InputProps?.readOnly ?? false

	return (
		<MuiTextField
			{...props}
			css={{
				width: '100%',
				'& fieldset': { borderColor: grey[300] },

				'&.readOnly': {
					label: {
						color: grey[400],
					},

					'.MuiInput-root::before': {
						borderColor: grey[300],
					},

					'.MuiInput-root::after': {
						borderColor: grey[300],
					},

					'.MuiInput-input': {
						color: grey[500],
					},
				},
			}}
			className={`${props.className ?? ''} ${isReadOnly ? 'readOnly' : ''}`}
		/>
	)
}
